import { render, staticRenderFns } from "./CommentContent.vue?vue&type=template&id=92a44660&scoped=true"
import script from "./CommentContent.vue?vue&type=script&lang=js"
export * from "./CommentContent.vue?vue&type=script&lang=js"
import style0 from "./CommentContent.vue?vue&type=style&index=0&id=92a44660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a44660",
  null
  
)

export default component.exports